import React, { useState } from 'react';

interface Props {
  initialColIds: string[];
  onApply: (colIds: string[]) => void;
}

const availableColumns = [
  'Manufacturer',
  'ProdType',
  'CatNum',
  'Brand',
  'Desc',
  'Usage',
  'Qty',
  'OnOrder',
  'Par',
  'Freq',
  'MaxUsage',
  'Suggested',
  'LastUsed',
  'Actions',
];

export default function CriteriaPanel({ initialColIds, onApply }: Props) {
  const [selected, setSelected] = useState<string[]>(initialColIds);

  const toggle = (col: string) => {
    setSelected(prev => prev.includes(col) ? prev.filter(c => c !== col) : [...prev, col]);
  };

  return (
    <div className='alert alert-secondary'>
      <div className='mb-2'><strong>Select Columns</strong></div>
      <div className='d-flex flex-wrap gap-2'>
        {availableColumns.map(col => (
          <label key={col} className='me-3'>
            <input type='checkbox' checked={selected.includes(col)} onChange={() => toggle(col)} />{' '}{col}
          </label>
        ))}
      </div>
      <div className='mt-2'>
        <button className='btn btn-primary' onClick={() => onApply(selected)}>Apply</button>
      </div>
    </div>
  );
}
